import { render, staticRenderFns } from "./CourseRelatedCarousel.vue?vue&type=template&id=6927b112&scoped=true"
import script from "./CourseRelatedCarousel.vue?vue&type=script&lang=js"
export * from "./CourseRelatedCarousel.vue?vue&type=script&lang=js"
import style0 from "./CourseRelatedCarousel.vue?vue&type=style&index=0&id=6927b112&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6927b112",
  null
  
)

export default component.exports